module.exports = __webpack_public_path__ + "static/img/icon_third.1748ad27.png";